/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InternalApiCurrentUserAvailableOrganisation
 */
export interface InternalApiCurrentUserAvailableOrganisation {
    /**
     * 
     * @type {number}
     * @memberof InternalApiCurrentUserAvailableOrganisation
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof InternalApiCurrentUserAvailableOrganisation
     */
    name: string;
}

/**
 * Check if a given object implements the InternalApiCurrentUserAvailableOrganisation interface.
 */
export function instanceOfInternalApiCurrentUserAvailableOrganisation(value: object): value is InternalApiCurrentUserAvailableOrganisation {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function InternalApiCurrentUserAvailableOrganisationFromJSON(json: any): InternalApiCurrentUserAvailableOrganisation {
    return InternalApiCurrentUserAvailableOrganisationFromJSONTyped(json, false);
}

export function InternalApiCurrentUserAvailableOrganisationFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiCurrentUserAvailableOrganisation {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
    };
}

export function InternalApiCurrentUserAvailableOrganisationToJSON(json: any): InternalApiCurrentUserAvailableOrganisation {
    return InternalApiCurrentUserAvailableOrganisationToJSONTyped(json, false);
}

export function InternalApiCurrentUserAvailableOrganisationToJSONTyped(value?: InternalApiCurrentUserAvailableOrganisation | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
    };
}

